module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 

var fontService = require('FontService').default;

var size = fontService.getFontSizes();
var fonts = fontService.getFonts();

var border = [1,2,3,4,5,7,9];
var radius = [0,1,2,3,4,5,7,9];

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Inputs</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Text</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"inputText\" name=\"inputTextColor\" type=\"color\" value=\"")
    ; __append(escapeFn( inputTextColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"inputTextColor\" name=\"inputTextColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( inputTextColor ))
    ; __append("\" />\r\n\r\n            <select name=\"inputFont\" class=\"style-font\"  id=\"inputFont\">\r\n              \r\n            </select>\r\n\r\n            <select name=\"inputFontSize\" id=\"inputFontSize\" class=\"style-font-size\">\r\n                ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <img id=\"inputBold\" class=\"weightSelectorInput\" name=\"inputWeight\" title=\"Bold\" src=\"")
    ; __append( require('editor/icons/bold-23.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( inputWeightSelection ))
    ; __append("\" />\r\n            <img id=\"inputItalic\" class=\"styleSelectorInput\" name=\"inputStyle\" title=\"Italic\" src=\"")
    ; __append( require('editor/icons/italic-23.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( inputStyleSelection ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Border</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"inputBorder\" name=\"inputBorderColor\" type=\"color\" value=\"")
    ; __append(escapeFn( inputBorderColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"inputBorderColor\" name=\"inputBorderColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( inputBorderColor ))
    ; __append("\" />\r\n\r\n            <select name=\"inputBorderStyle\" class=\"style-font\"  id=\"inputBorderStyle\">\r\n                <option value=\"none\">None</option>\r\n                <option value=\"solid\">Solid</option>\r\n            </select>\r\n\r\n            <select name=\"inputBorderWidth\" id=\"inputBorderWidth\" class=\"style-border-size\">\r\n                ")
    ;  for (var i = 0; i < border.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(border[i]))
    ; __append("\">")
    ; __append(escapeFn(border[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n\r\n            <select name=\"inputBorderRadius\" id=\"inputBorderRadius\" class=\"style-border-radius input-style-border-radius\">\r\n                ")
    ;  for (var i = 0; i < radius.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(radius[i]))
    ; __append("\">")
    ; __append(escapeFn(radius[i]))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n                <option></option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Background</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"inputBackground\" name=\"inputBgColor\" type=\"color\" value=\"")
    ; __append(escapeFn( inputBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"inputBgColor\" name=\"inputBgColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( inputBgColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}